import { routes } from "consts";
import React from "react";
import { ChangelogArticle, ChangelogBody, LinkTo } from "../components";

export const Article20240921 = (): JSX.Element | null => {
  return (
    <ChangelogArticle date="21 Wrzesień, 2024" header="Nowa wersja 1.2.0" labels={["bugfix", "feature"]}>
      <ChangelogBody title="1. Edycja kursu">
        Na ekranie <LinkTo to={routes.COURSES_EDIT_NESTED.PREVIEW("1")}>edycji kursu</LinkTo>, pole edycji krótkiego
        opisu, zostało zastąpione przez edytor WYSIWYG.
      </ChangelogBody>

      <ChangelogBody title="2. Tworzenie i edycja trenera">
        Na ekranie <LinkTo to={routes.TRAINERS_ADD}>tworzenia trenera</LinkTo> poprawiono:
        <ul>
          <li>- Dodanie walidacji dla pola "Finanse"</li>
          <li>
            - Dodano brakujący tytuł: <b>lek. wet.</b>
          </li>
        </ul>
      </ChangelogBody>
      <ChangelogBody title="3. Usuwanie zjazdów">
        Usunięcie zjazdu usuwa również powiązane wydarzenia w harmonogramie kursu.
      </ChangelogBody>
      <ChangelogBody title="4. Monitoring Sentry">
        Zainstalowano system monitorowania Sentry, w celu śledzenia niepowodzeń i błędów systemu.
      </ChangelogBody>
      <ChangelogBody title="5. Zapamiętywanie filtrów">
        Dodano zapamiętywanie filtrów na następujących stronach:
        <ul>
          <li>
            <LinkTo to={routes.TOPICS}>- Tematy</LinkTo>
          </li>
          <li>
            <LinkTo to={routes.TOPICS_GROUPS}>- Grupy tematów</LinkTo>
          </li>
          <li>
            <LinkTo to={routes.TRAINERS}>- Trenerzy</LinkTo>
          </li>
          <li>
            <LinkTo to={routes.EMAILS}>- Historia wiadomości email</LinkTo>
          </li>
          <li>
            <LinkTo to={routes.USER_SURVEYS}>- Ankiety użytkowników</LinkTo>
          </li>
        </ul>
      </ChangelogBody>
      <ChangelogBody title="6. Dokumenty - rozbudowane placeholdery HTML">
        <b className="text-orange-500">{"(beta)"}</b> W <LinkTo to={routes.DOCUMENTS}>szablonach dokumentów </LinkTo>{" "}
        dodano możliwość wstawiania rozbudowanych placehoderów HTML.
      </ChangelogBody>
    </ChangelogArticle>
  );
};
